import { createRequest } from '@savgroup-front-common/core/services/request';

export const LOAD_REFUNDS = createRequest('LOAD_REFUNDS');
export const RESET_REFUND_STATUS = 'RESET_REFUND_STATUS';
